<template>
	<div class="per_right">
		<div class="per_right_1 clearfix">
			<img src="@/images/center_title.png" class="per_right_1back" />
			<img src="@/images/center_text13.png" class="per_right_1name" />
		</div>
		<div class="per_right_2">
			<div class="app_right_bottom">
				<i class="el-icon-s-marketing"></i> 我的总学习时长：{{lengthData.studyTimeLength | tofixTime}}
			</div>
		</div>
		<div style="width: calc(100% - 120px);margin: 0 auto 30px;">
			<el-row :gutter="40">
				<el-col :span='24'>
					<div class="minheight400" id='loginStudentStatistical'></div>
				</el-col>
				<el-col :span='24'>
					<div class="minheight400" id='myCourseStatistical'></div>
				</el-col>
			</el-row>
		</div>
		<div style="width: calc(100% - 120px);margin: 0 auto 30px;">
			<el-row :gutter="40">
				<el-col :span='24'>
					<div class="minheight400" id='myTaskInfoStatisticalNote'></div>
				</el-col>
				<el-col :span='24' style="margin:0 0 80px 0;">
					<div class="minheight400" id='myTaskInfoStatistical'></div>
				</el-col>
				<el-col :span='24' style="margin:0 0 50px 0;">
					<div class="minheight400" id='myExamInfoStatistical'></div>
				</el-col>
			</el-row>
		</div>
	</div>
	</div>
</template>

<script>
	import echarts from 'echarts'
	require('echarts/theme/macarons')
	import { loginStudentStatistical, myCourseStatistical, myTaskInfoStatistical, myExamInfoStatistical } from '@/api/statistical.js'
	export default {
		props: {
			majorid: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				lengthData: {}
			};
		},
		created() {
			this.getUserData()
		},
		methods: {
			getUserData() {
				loginStudentStatistical().then(res => {
					this.lengthData = res.data;
					var option = {
						title: {
							text: '课程学习详情',
						},
						tooltip: {},
						radar: {
							radius: '66%',
							center: ['50%', '42%'],
							splitNumber: 8,
							splitArea: {
								areaStyle: {
									color: 'rgba(127,95,132,.3)',
									opacity: 1,
									shadowBlur: 45,
									shadowColor: 'rgba(0,0,0,.5)',
									shadowOffsetX: 0,
									shadowOffsetY: 15
								}
							},
							indicator: [{
									name: '学习课程数',
									max: 40
								},
								{
									name: '课程笔记总数',
									max: 40
								},
								{
									name: '作业总次数',
									max: 40
								},
								{
									name: '考试总次数',
									max: 40
								},
								{
									name: '评论的次数',
									max: 40
								},
								{
									name: '回复的次数',
									max: 40
								}
							]
						},
						legend: {
							left: 'center',
							bottom: '10',
							data: ['我的学习数据']
						},
						series: [{
							type: 'radar',
							symbolSize: 0,
							areaStyle: {
								normal: {
									shadowBlur: 13,
									shadowColor: 'rgba(0,0,0,.2)',
									shadowOffsetX: 0,
									shadowOffsetY: 10,
									opacity: 1
								}
							},
							data: [{
								value: [res.data.courseTotal, res.data.notes, res.data.taskTotal, res.data.examTotal, res.data.commentsTotal, res.data.replyTotal],
								name: '我的学习数据'
							}],
							animationDuration: 3000
						}]
					}
					var myChart = echarts.init(document.getElementById('loginStudentStatistical'));
					myChart.setOption(option)
				});
				myCourseStatistical({
					majorId: this.majorid
				}).then(res => {
					if(res.code == 0) {
						const {
							data
						} = res;
						var courseName = [];
						var finish = [];
						var notes = [];
						data.map(item => {
							courseName.push(item.courseName);
							finish.push(item.finish ? item.finish * 100 : 0);
							if(item.notes && item.notes > 0) {
								notes.push({
									name: item.courseName,
									value: item.notes,
								});
							}
						})
						var option = {
							title: {
								text: '课程学习进度',
							},
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									type: 'shadow'
								},
								formatter: '{b} <br/>{a} : {c}%'
							},
							toolbox: {
								show: true,
								orient: 'vertical',
								left: 'right',
								top: 'center',
							},
							xAxis: {
								type: 'category',
								data: courseName,
								axisLabel: {
									interval: 0,
									rotate: 15,
									textStyle: {
										color: "black",
										fontSize: 12,
										fontWeight: 'initial',
										fontFamily: 'Microsoft YaHei'
									}
								}
							},
							yAxis: {
								type: 'value',
								minInterval: 1,
								name: '百分比',
							},
							series: [{
								name: '课程学习进度',
								data: finish,
								type: 'bar',
								barWidth: 30,
								showBackground: true,
								itemStyle: {
									color: 'rgba(51,108,255,1)',
								},
								lineStyle: {
									width: 2,
								},
								areaStyle: {
									normal: {
										color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
											offset: 0,
											color: 'rgba(51,108,255,0.4)'
										}, {
											offset: 1,
											color: 'rgba(108,199,255,0.05)'
										}])
									}
								},
							}]
						};
						var myChart = echarts.init(document.getElementById('myCourseStatistical'));
						myChart.setOption(option);
						var pieOption = {
							title: {
								text: '课程笔记数量',
							},
							tooltip: {
								trigger: 'item',
								formatter: '{a} <br/>{b} : {c} ({d}%)'
							},
							legend: {
								type: 'scroll',
								orient: 'vertical',
								right: 10,
								top: 20,
								bottom: 20,
							},
							series: [{
								name: '笔记数量',
								type: 'pie',
								radius: '55%',
								data: notes,
								lineStyle: {
									width: 2,
								},
								areaStyle: {
									normal: {
										color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
											offset: 0,
											color: 'rgba(51,108,255,0.4)'
										}, {
											offset: 1,
											color: 'rgba(108,199,255,0.05)'
										}])
									}
								},
							}]
						};
						var pieChart = echarts.init(document.getElementById('myTaskInfoStatisticalNote'));
						pieChart.setOption(pieOption);
					}
				})
				myTaskInfoStatistical({
					majorId: this.majorid
				}).then(res => {
					const {
						data
					} = res;
					var time = [];
					var name = [];
					var score = [];
					data.map(item => {
						time.push(item.time ? item.time.split('T').join(' ') : '');
						score.push({
							name: item.name,
							value: item.score,
						});
					})
					var option = {
						title: {
							text: '作业成绩详情',
						},
						xAxis: [{
							show: true,
							type: 'category',
							boundaryGap: false,
							data: time,
							axisLine: {
								show: false
							},
							axisTick: {
								alignWithLabel: true,
								show: false
							},
							splitLine: {
								show: false,
								lineStyle: {
									color: '#ebebeb',
									type: 'dashed',
								}
							},
						}],
						grid: {
							left: '35px',
							right: '70px',
							bottom: '10px',
							top: '50px',
							containLabel: true
						},

						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'line',
								lineStyle: {
									color: '#E9F2FF'
								}
							},
							textStyle: {
								fontSize: 12,
								color: '#FFF'
							},
							backgroundColor: '#3A8BFF',
							extraCssText: 'padding:10px 16px; line-height:18px;border-radius:6px;',
							formatter: '{b} <br/>{a} : {c} '
						},
						yAxis: [{
							type: 'value',
							splitNumber: 3,
							axisLabel: {
								textStyle: {
									color: '#A8A8B3',
									fontSize: 12
								},
							},
							axisLine: {
								show: false
							},
							axisTick: {
								alignWithLabel: true,
								show: false
							},
							splitLine: {
								show: true,
								lineStyle: {
									color: 'rgba(39,125,255,0.10)',
									type: 'dashed',
								}
							},
						}],
						series: [{
							name: '作业成绩',
							data: score,
							type: 'line',
							symbolSize: 0,
							showSymbol: false,
							itemStyle: {
								color: 'rgba(51,108,255,1)',
							},
							lineStyle: {
								width: 2,
							},
							areaStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: 'rgba(51,108,255,0.4)'
									}, {
										offset: 1,
										color: 'rgba(108,199,255,0.05)'
									}])
								}
							},
						}]
					};
					var myChart = echarts.init(document.getElementById('myTaskInfoStatistical'));
					myChart.setOption(option);
				})
				myExamInfoStatistical().then(res => {
					const {
						data
					} = res;
					var time = [];
					var name = [];
					var score = [];
					data.map(item => {
						time.push(item.time ? item.time.split('T').join(' ') : '');
						score.push({
							name: item.name,
							value: item.score,
						});
					})
					var option = {
						title: {
							text: '考核成绩详情',
						},
						xAxis: [{
							show: true,
							type: 'category',
							boundaryGap: false,
							data: time,
							axisLine: {
								show: false
							},
							axisTick: {
								alignWithLabel: true,
								show: false
							},
							splitLine: {
								show: false,
								lineStyle: {
									color: '#ebebeb',
									type: 'dashed',
								}
							},
						}],
						grid: {
							left: '35px',
							right: '70px',
							bottom: '10px',
							top: '50px',
							width: '100%',
							containLabel: true
						},

						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'line',
								lineStyle: {
									color: '#E9F2FF'
								}
							},
							textStyle: {
								fontSize: 12,
								color: '#FFF'
							},
							backgroundColor: '#3A8BFF',
							extraCssText: 'padding:10px 16px; line-height:18px;border-radius:6px;',
							formatter: '{b} <br/>{a} : {c} '
						},
						yAxis: [{
							type: 'value',
							splitNumber: 3,
							axisLabel: {
								textStyle: {
									color: '#A8A8B3',
									fontSize: 12
								},
							},
							axisLine: {
								show: false
							},
							axisTick: {
								alignWithLabel: true,
								show: false
							},
							splitLine: {
								show: true,
								lineStyle: {
									color: 'rgba(39,125,255,0.10)',
									type: 'dashed',
								}
							},
						}],
						series: [{
							name: '考核成绩',
							data: score,
							type: 'line',
							symbolSize: 0,
							showSymbol: false,
							itemStyle: {
								color: 'rgba(51,108,255,1)',
							},
							lineStyle: {
								width: 2,
							},
							areaStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: 'rgba(51,108,255,0.4)'
									}, {
										offset: 1,
										color: 'rgba(108,199,255,0.05)'
									}])
								}
							},
						}]
					};
					var myChart = echarts.init(document.getElementById('myExamInfoStatistical'));
					myChart.setOption(option);
				})
			},
		},
	};
</script>

<style scoped="scoped">
	.minheight400 {
		min-height: 400px;
	}
</style>